/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "vtoxzvdweesomgfqfdqx"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZ0b3h6dmR3ZWVzb21nZnFmZHF4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg5MjU5MjMsImV4cCI6MjA4NDUwMTkyM30.uaQYMQdMkMUqI6aJ_JmIPwYp86KhUDnrd5QY4nMNo-w"